import { Color } from '@gousto-internal/citrus-react'
import { isRecipeFineDineIn, Recipe } from '@library/menu-service'

export const getOverlayColor = (recipe: Recipe) => {
  const isFineDineIn = isRecipeFineDineIn(recipe)

  return isFineDineIn ? Color.ColdGrey_800 : Color.White
}
